import parse from "html-react-parser";
import React from "react";
import "./emptyStateComponent.scss";
import { isMobile } from "../../bridges/BridgeServices";

const EmptyStateComponent = ({
  title,
  subTitle,
  icon,
  image,
  wrapperClassName,
}) => {
  return (
    <div
      className={`${
        isMobile()
          ? "mobile-no-results-container"
          : "no-results-container"
      } ${wrapperClassName}`}
    >
      {icon && (
        <div
          className={`${
            isMobile()
              ? "mobile-no-results-svg"
              : "no-results-svg"
          }`}
        >
          {parse(icon)}
        </div>
      )}
      {image && <img src={image} className="image" />}
      <div
        className={`${
          isMobile()
            ? "mobile-no-results-heading"
            : "no-results-heading"
        }`}
      >
        {title}
      </div>
      <div
        className={`${
          isMobile()
            ? "mobile-no-results-subtitle"
            : "no-results-subtitle"
        }`}
      >
        {subTitle}
      </div>
    </div>
  );
};

export default EmptyStateComponent;
